/* eslint react-hooks/rules-of-hooks: "warn" */
import { getGroupExtension, useFramework } from '@/framework';
import { getLocaleStore } from '@/i18n';
import { Layer } from '@/layers/layer';
import { GroupRoleType, IPuzzleLayer, LayerType } from '@/version-types';
import { IExportContextMenuItem, IRenderContextMenuItemArgs } from '../../../type';
import MenuItem from '../../../views/menu-item';

const render = ({ activeLayer, pickLayer, operateLayerType }: IRenderContextMenuItemArgs) => {
    const { $t } = getLocaleStore();
    const framework = useFramework();
    const layer = pickLayer || activeLayer;
    const disabled = !layer;
    if (disabled || operateLayerType !== LayerType.GROUP_LAYER) return null;

    // 拼图禁用
    const extension = getGroupExtension<IPuzzleLayer>(layer);
    if (extension && extension.role === GroupRoleType.PUZZLE) return null;

    const clickHandler = (type: string) => {
        const dependenciesAPI = framework.getInstance(Layer);
        dependenciesAPI.groupAlign[type]?.(activeLayer?.id);
    };

    const item = {
        disabled,
        name: $t((v) => v.contextMenuLayer.menuConfig.alignElement),
        type: 'alignInner',
        childMenus: [
            {
                name: $t((v) => v.contextMenuLayer.menuConfig.alignLeft),
                type: 'left',
                icon: 'AlignLeftBold',
                onClick: () => clickHandler('left'),
            },
            {
                name: $t((v) => v.contextMenuLayer.menuConfig.alignHorizontal),
                type: 'horizontalCenter',
                icon: 'AlignHorizontalCenterBold',
                onClick: () => clickHandler('horizontalCenter'),
            },
            {
                name: $t((v) => v.contextMenuLayer.menuConfig.alignRight),
                type: 'right',
                icon: 'AlignRightBold',
                onClick: () => clickHandler('right'),
            },
            {
                name: $t((v) => v.contextMenuLayer.menuConfig.alignTop),
                type: 'top',
                icon: 'AlignTopBold',
                onClick: () => clickHandler('top'),
            },
            {
                name: $t((v) => v.contextMenuLayer.menuConfig.alignVertical),
                type: 'verticalCenter',
                icon: 'AlignVerticalCenterBold',
                onClick: () => clickHandler('verticalCenter'),
            },
            {
                name: $t((v) => v.contextMenuLayer.menuConfig.alignBottom),
                type: 'bottom',
                icon: 'AlignBottomBold',
                onClick: () => clickHandler('bottom'),
            },
            {
                name: $t((v) => v.contextMenuLayer.menuConfig.horizontalDistribution),
                disabled: !!(activeLayer?.children.length && activeLayer?.children.length < 3),
                type: 'horizontalDistribution',
                icon: 'HorizontalDistributionBold',
                onClick: () => clickHandler('horizontalDistribution'),
            },
            {
                name: $t((v) => v.contextMenuLayer.menuConfig.verticalDistribution),
                disabled: !!(activeLayer?.children.length && activeLayer?.children.length < 3),
                type: 'verticalDistribution',
                icon: 'VerticalDistributionBold',
                onClick: () => clickHandler('verticalDistribution'),
            },
        ],
    };

    return <MenuItem {...item}></MenuItem>;
};

export default {
    group: 4,
    sort: 2,
    render,
} as IExportContextMenuItem;
